<ng-container *ngIf="invoiceInfo === null || lookingForAnotherCompany">
  <company-searcher
    class="d-block my-3"
    [bakeryId]="bakeryId"
    [allowToChangeCountry]="allowToChangeCountry"
    [countryCode]="invoiceInfo?.company?.legalCompany?.country || countryCode"
    [showCancel]="lookingForAnotherCompany"
    [isForPayment]="isForPayment"
    (onCancel)="lookingForAnotherCompany = false"
    (onCompanyFound)="continueWithCompany($event)"
  ></company-searcher>
</ng-container>

<ng-container *ngIf="invoiceInfo !== null && !lookingForAnotherCompany">
  <!-- TODO get rid of afterContentInit -->
  <form #invoiceInfoForm="ngForm"
        options=""
        [afterContentInit]="registerForm.bind(this, invoiceInfoForm)"
        autocomplete="off">
    <div class="form-group mb-{{ isSharedBusinessAccount ? 3 : 0}}">
      <label class="font-xl fw-bold">{{ 'common.companyName' | translate }}</label>

      <div class="org-name-org-number">
        <input class="form-control"
               type="text" disabled
               name="orgName"
               [ngModel]="invoiceInfo.orgName"
               (ngModelChange)="invoiceInfoForm.valid" />

        <div class="invoice-info-org-number font-md">
          {{ invoiceInfo.orgNumber }}
        </div>
      </div>

      <div class="text-end"
           *ngIf="!isSharedBusinessAccount">
        <button type="button" class="btn btn-link pt-1 pe-0" (click)="changeCompany()">
          {{ 'orderProcess.payment.userInvoiceInfo.changeCompany' | translate }}
        </button>
      </div>
    </div>

    <ng-content></ng-content>

    <ng-container *ngIf="showInvoiceFormat">
      <div class="form-group">
        <label class="font-xl fw-bold">
          {{ 'orderProcess.payment.userInvoiceInfo.howSendInvoice' | translate }}
        </label>

        <ui-radio-group
          class="d-block"
          [model]="currentInvoiceFormat"
          (modelChange)="onInvoiceFormatUpdated($event)"
          [items]="FORMATS">
        </ui-radio-group>
      </div>

      <div class="form-group position-relative" *ngIf="!isEhf()">
        <label class="font-xl fw-bold">
          {{ 'orderProcess.payment.userInvoiceInfo.whichEmail' | translate }}
        </label>

        <ui-input-with-tooltip
          [tooltipText]="'orderProcess.payment.userInvoiceInfo.typeEmailAddress' | translate">
          <input class="form-control"
                 required
                 [name]="'email'"
                 [maxlength]="'128'"
                 [pattern]="EMAIL_PATTERN"
                 [placeholder]="'orderProcess.payment.userInvoiceInfo.invoiceEmailPlaceholder' | translate"
                 [(ngModel)]="invoiceInfo.email" />
        </ui-input-with-tooltip>

        <ui-email-misspelled
          class="d-block mt-1"
          [email]="invoiceInfo.email"
        ></ui-email-misspelled>
      </div>
    </ng-container>

    <label class="font-xl fw-bold">
      {{ 'orderProcess.payment.userInvoiceInfo.referenceComment' | translate }}
      <small
        class="fw-normal"
        [class.text-danger]="invoiceRefRequired">
        <ng-container *ngIf="invoiceRefRequired">
          {{ 'common.required' | translate }}
        </ng-container>
        <ng-container *ngIf="!invoiceRefRequired">
          ({{ 'common.optional' | translate }})
        </ng-container>
      </small>
    </label>

    <ui-input-with-tooltip
      [tooltipText]="'orderProcess.payment.userInvoiceInfo.typeReferenceNumber' | translate">
      <input
        class="form-control"
        [required]="invoiceRefRequired"
        [name]="'reference'"
        [maxlength]="'128'"
        [placeholder]="'orderProcess.payment.userInvoiceInfo.invoiceReference' | translate"
        [(ngModel)]="invoiceInfo.reference" />
    </ui-input-with-tooltip>
  </form>

  <div class="text-end mt-4" *ngIf="showRemove && invoiceInfo?.id">
    <button class="btn btn-text-pink fw-bold font-lg"
            (click)="removeInvoiceInfo()"
            [translate]="'orderProcess.payment.userInvoiceInfo.remove'">
      Remove info
    </button>
  </div>
</ng-container>
